import { useResourceParams } from '@refinedev/core';
import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import { FAIL_REPORT_URLS } from '@/constants/urls';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { RESOURCES } from '@/Resources';

const FailReportsSection = () => {
  const { action } = useResourceParams();

  useDocumentTitle({
    resourceTitle: 'Reportes de problemas',
    showTitle: 'Ver reporte de problema {id}',
    editTitle: 'Editar reporte de problema {id}',
    createTitle: 'Nuevo reporte de problema',
  });

  const { selectProps: ticketsSelectProps } = useSelectScrollSearch(
    {
      resource: RESOURCES.TICKETS,
      optionLabel: (item: any) =>
        `${item.id} - ${item.title ? item.title : item.ticket_title_str ? item.ticket_title_str : '-'}`,
      optionValue: (item: any) => item.id,
      meta: { saveItem: action == 'list' ? true : undefined },
    },
    { saveItem: true },
  );
  // Selectores
  const { selectProps: categorySelectProps } = useSelectScrollSearch({
    resource: FAIL_REPORT_URLS.FAIL_CATEGORIES,
    optionLabel: item => item.title,
    optionValue: item => item.id,
  });
  const isLoading = useMemo(
    () => ticketsSelectProps.loading || categorySelectProps.loading,
    [ticketsSelectProps.loading, categorySelectProps.loading],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="FailReportsSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet context={{ ticketsSelectProps, categorySelectProps }} />
      )}
    </div>
  );
};

export default FailReportsSection;
